<template>
  <div class="box-video">
    <div v-if="mydata.userFavoritesArr.length === 0">
      <p
        style="
          line-height: 300px;
          text-align: center;
          letter-spacing: 1px;
          color: #999999;
        "
      >
        暂无收藏
      </p>
    </div>
    <div class="box-online2" v-else>
      <researchProjects
        v-for="(item, index) in mydata.userFavoritesArr"
        :key="index"
        :info="item.content"
        :showBoxShadow="false"
        path="/layout/list/onlineDetails"
      >
        <template #img>
          <img
            v-complete:src="item.content.image"
            alt=""
            style="cursor: pointer"
          />
        </template>
        <template #Button>
          <el-tag>{{ byIdGetText(item.content.subject, "subject") }}</el-tag>
        </template>
        <!-- <template #Button>
          <el-tag v-if="item.class_stage_text">{{
            item.class_stage_text
          }}</el-tag>
          <el-tag v-if="item.classes_text">{{ item.classes_text }}</el-tag>
          <el-tag v-if="item.subject_text">{{ item.subject_text }}</el-tag>
          <el-tag v-for="(item, index) in item.tags" :key="index">{{
            item.name
          }}</el-tag>
        </template> -->
      </researchProjects>
    </div>

    <!--分页 -->
    <div
      class="gl-pagination"
      
    >
      <el-pagination
        v-model:currentPage="mydata.pageObj.currentPage"
        v-model:page-size="mydata.pageObj.pageSize"
        :total="mydata.pageObj.total"
        layout="prev, pager, next"
        pager-count="4"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script setup>
import researchProjects from "@/components/researchProjects/index.vue";

import { reactive } from "vue";

import { useRouter, useRoute } from "vue-router";
//引入我的收藏列表、取消收藏接口
import {
  userFavoritesList,
  delFavoritesList,
} from "@/api/personalCenter/myCollection/index.js";
import { ElMessage, ElMessageBox } from "element-plus";
const router = useRouter();
const route = useRoute();

const mydata = reactive({
  currentPage3: "5",
  pageSize3: "100",
  small: false,
  background: false,
  disabled: false,
  // 图片基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
  /////
  pageObj: {
    currentPage: 1, // 当前页数
    pageSize: 6, // 每页条数
    total: 0, // 总的条数
  },

  userFavoritesArr: [], //收藏列表

  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {}, //获取的用户信息

  type: "5", //写死-类型就是5

  subject: JSON.parse(localStorage.getItem("subject")) ?? [], //标签
});

// 通过ID得到对应文字————标签
function byIdGetText(id, key) {
  return mydata[key].find((item) => String(item.name) === String(id))?.label;
}

// 当前页数改变事件
function handleCurrentChange(val) {
  // 查询
  userFavoritesFn();
}

//获取收藏列表
function userFavoritesFn() {
  userFavoritesList(mydata.userInfo.jwt, {
    type: mydata.type,
    page: String(mydata.pageObj.currentPage),
    psize: String(mydata.pageObj.pageSize),
  }).then((res) => {
    mydata.userFavoritesArr = res.data.list;
    // console.log(res.data.list,"收藏")
    mydata.pageObj.total = res.data.count;
  });
}

userFavoritesFn();

//取消收藏
function cancelCollect(item) {
  ElMessageBox.confirm("是否取消收藏该条数据？", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      // 调用接口
      delFavoritesList(mydata.userInfo.jwt, { favorite_id: item.id }).then(
        (res) => {
          ElMessage({
            message: res.msg,
            type: "success",
          });
          // 查询列表
          userFavoritesFn();
        }
      );
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "已取消操作",
      });
    });
}
</script>

<style scoped lang="scss">
.box-video {
  ///////模块3
  .box-online2 {
   
    .box-project {
      // flex-shrink: 0;
      margin:0 auto;
      margin-top: 16px;
      // padding-bottom:16px;
      img {
         width: 343px !important;
        height: 201px !important;
        display: block;
      }
     
      .el-tag {
        background: #f0f5ff;
        color: #333333;
        font-size: 12px;
        border: 1px solid #c5cbce;
        // margin-top: -16px;
        margin-left: 16px;
        margin-right:5px;
        margin-bottom:16px;
        padding: 3px 8px 3px 8px;
        height: 26px;
      }
    }
    // .box-project:nth-of-type(3n) {
    //   margin-right: 0px;
    // }
  }

  //////////分页
  .paging {
    // margin: 0 auto;
    display: flex;
    justify-content: center;
    margin-top: 40px;
    margin-bottom: 40px;
    :deep(.el-button.is-plain) {
      margin-left: 24px;
    }
  }
  //最左边的箭头
  :deep(.btn-prev.is-first) {
    margin-right: 12px;
    background-color: #f5f6f7;
  }
  :deep(.btn-next) {
    background-color: #f5f6f7;
  }
  //每个页
  :deep(.number) {
    margin-right: 12px;
    // color:#BBBDBF;
    background-color: #f5f6f7;
  }
  //省略号
  :deep(.more.btn-quicknext.el-icon) {
    margin-right: 12px;
    background-color: #f9f9f9;
  }

  .demo-pagination-block + .demo-pagination-block {
    margin-top: 10px;
  }
  .demo-pagination-block .demonstration {
    margin-bottom: 16px;
  }
}

:deep(.box-project) {
  cursor: pointer;
}
</style>